export default __webpack_public_path__ + "static/media/border-radius-top-right.5d6db8e5.svg";